const DEFAULT_SPEED = 80; // px/s

class MarqueeItem {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector(".marquee__track");
    this.list = this.track.querySelector(".marquee__list");
    this.speed = parseFloat(el.dataset.marqueeSpeed) || DEFAULT_SPEED;

    this._setup();

    this._observer = new ResizeObserver(() => this._setup());
    this._observer.observe(this.el);
  }

  _setup() {
    this._removeClones();
    this._addClones();
    this._setAnimation();
  }

  _removeClones() {
    this.track
      .querySelectorAll('[aria-hidden="true"]')
      .forEach((el) => el.remove());
  }

  _addClones() {
    const listWidth = this.list.scrollWidth;
    const containerWidth = this.el.offsetWidth;

    if (!listWidth || !containerWidth) return;

    const needed = Math.ceil((containerWidth + listWidth) / listWidth);
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < needed; i++) {
      const clone = this.list.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      fragment.appendChild(clone);
    }

    this.track.appendChild(fragment);
  }

  _setAnimation() {
    const listWidth = this.list.scrollWidth;
    if (!listWidth) return;

    const duration = listWidth / this.speed;

    this.track.style.setProperty("--_marquee-duration", `${duration}s`);
    this.track.style.setProperty("--_marquee-offset", `-${listWidth}px`);
  }

  destroy() {
    this._observer?.disconnect();
    this._removeClones();
    this.track.style.removeProperty("--_marquee-duration");
    this.track.style.removeProperty("--_marquee-offset");
  }
}

const Marquee = () => {
  const elements = document.querySelectorAll(".marquee");
  if (!elements.length) return;

  elements.forEach((el) => new MarqueeItem(el));
};

export default Marquee;
